/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_Audio_Starting_StatusInputs */

const en_render_audio_starting_status = /** @type {(inputs: Render_Audio_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting audio render...`)
};

const fr_render_audio_starting_status = /** @type {(inputs: Render_Audio_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demarrage du rendu audio...`)
};

const de_render_audio_starting_status = /** @type {(inputs: Render_Audio_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio-Rendering wird gestartet...`)
};

const it_render_audio_starting_status = /** @type {(inputs: Render_Audio_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio rendering audio...`)
};

const ru_render_audio_starting_status = /** @type {(inputs: Render_Audio_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начало обработки звука...`)
};

const es_render_audio_starting_status = /** @type {(inputs: Render_Audio_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando la renderización de audio...`)
};

const zh_cn2_render_audio_starting_status = /** @type {(inputs: Render_Audio_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始音频渲染……`)
};

const ja_render_audio_starting_status = /** @type {(inputs: Render_Audio_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオのレンダリングを開始しています...`)
};

const hi_render_audio_starting_status = /** @type {(inputs: Render_Audio_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो रेंडरिंग शुरू हो रही है...`)
};

const pt_pt2_render_audio_starting_status = /** @type {(inputs: Render_Audio_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando a renderização de áudio...`)
};

/**
* | output |
* | --- |
* | "Starting audio render..." |
*
* @param {Render_Audio_Starting_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_starting_status = /** @type {((inputs?: Render_Audio_Starting_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Starting_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_render_audio_starting_status(inputs)
	if (locale === "de") return de_render_audio_starting_status(inputs)
	if (locale === "it") return it_render_audio_starting_status(inputs)
	if (locale === "ru") return ru_render_audio_starting_status(inputs)
	if (locale === "es") return es_render_audio_starting_status(inputs)
	if (locale === "zh-CN") return zh_cn2_render_audio_starting_status(inputs)
	if (locale === "ja") return ja_render_audio_starting_status(inputs)
	if (locale === "hi") return hi_render_audio_starting_status(inputs)
	if (locale === "pt-PT") return pt_pt2_render_audio_starting_status(inputs)
	return en_render_audio_starting_status(inputs)
});